import {Formik} from 'formik';
import {
    ActionBar,
    FormWithActionBar,
    NextSubmitButton,
    PacFormikComponentState
} from "@pac/platform-ui-components";

import {ValidationSchema} from "../../credentials/forms/CredentialsFormValidationSchema.ts";
import {FormComponent} from "./FormComponent.tsx";
import {HandoffCredentials} from "../types.ts";

export const HandoffSignInForm = ({
                                      emailAddress,
                                      handleSubmit
                                  }: {
    emailAddress: string,
    handleSubmit: (values: HandoffCredentials) => Promise<void>
}) => {

    const initialValues: HandoffCredentials = {
        email: emailAddress,
        password: '',
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={ValidationSchema}
            onSubmit={handleSubmit}
        >
            {(props) => (
                <FormWithActionBar
                    handleSubmit={props.handleSubmit}
                    actionBar={<ActionBar primaryAction={<NextSubmitButton loading={props.isSubmitting}/>}/>}
                >
                    <FormComponent {...props} />
                    <PacFormikComponentState enabled={false} {...props} />
                </FormWithActionBar>
            )}
        </Formik>
    );
};
